import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Zap, Bell, Shield, Coins, LineChart } from 'lucide-react';
import { Translations } from '../types';
import SpotlightCard from './SpotlightCard';

interface FeaturesProps {
  t: Translations;
}

const icons = [Brain, Zap, Bell, Shield, Coins, LineChart];

export const Features: React.FC<FeaturesProps> = ({ t }) => {
  return (
    <section className="features" aria-labelledby="features-heading" id="features">
      <div className="floating-elements" aria-hidden="true">
        <div className="floating-element">BTC: $67,234</div>
        <div className="floating-element">ETH: $3,456</div>
        <div className="floating-element">AI_SCORE: 0.89</div>
        <div className="floating-element">VOL: 12.4M</div>
        <div className="floating-element">RSI: 72.3</div>
      </div>
      <div className="container">
        <motion.h2
          id="features-heading"
          className="features-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {t.features.title}
        </motion.h2>

        <div className="features-grid" role="list" aria-label="产品功能列表">
          {t.features.items.map((feature, index) => {
            const Icon = icons[index % icons.length];
            return (
              <motion.article
                key={index}
                role="listitem"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <SpotlightCard 
                  className="feature-card"
                  spotlightColor="rgba(0, 255, 157, 0.12)"
                >
                  <div className="feature-icon" aria-hidden="true">
                    <Icon size={40} />
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </SpotlightCard>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}; 
